import addon from './addon.vue';
import config from './config'
import pre from './pre';

export default {
  pre,
  components: {
    addon,
    config,
  },
}
